import useSWR from 'swr'
import type { User } from '@/lib/types'
import { fetcher } from '@/lib/utils'

export const useCurrentUser = (options?: { fallbackData?: User | null }) => {
  const { data, isLoading, error, mutate } = useSWR<User | null>(
    '/api/me',
    fetcher,
    {
      fallbackData: options?.fallbackData,
      revalidateOnFocus: false,
      revalidateIfStale: true,
      revalidateOnReconnect: false,
      dedupingInterval: 30 * 60 * 1000, // Cache for 30 minutes
    },
  )

  const isInternalUser = data?.roles?.some((role) =>
    ['admin', 'team'].includes(role),
  )

  return {
    data,
    user: data,
    isLoading,
    isLoadingUser: isLoading,
    isInternalUser,
    isSystemAdmin: data?.roles?.some((role) => role === 'super'),
    error,
    mutate,
  }
}
